import loadSessionModule from './modules/Session.module';
const loadProductWizardModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule()],
});
export default loadProductWizardModule;
